<div
  class="ngx-awesome-popup-overlay confirm-box-overlay"
  (dblclick)="onOverlayClicked($event)"
  [@fadeInOut]="{
    value: fadeInOutAnimation,
    params: {
      closeDelay: confirmBoxBelonging.confirmBoxCoreConfig.animationOut === disappearanceAnimation.NONE ? '200ms' : '300ms'
    }
  }">
  <div
    [@.disabled]="
      confirmBoxBelonging.confirmBoxCoreConfig.animationIn === appearanceAnimation.NONE &&
      confirmBoxBelonging.confirmBoxCoreConfig.animationOut === disappearanceAnimation.NONE
    "
    [@boxAnimations]="boxAnimation"
    #elConfirmBoxWrapper
    [className]="layoutHelper.getBoxClasses(confirmBoxBelonging.confirmBoxCoreConfig.layoutType, 'evolve-confirm-box')"
    [ngStyle]="{
      width: confirmBoxBelonging.confirmBoxCoreConfig.width,
      height: confirmBoxBelonging.confirmBoxCoreConfig.height,
      opacity: confirmBoxBelonging.confirmBoxCoreConfig.animationIn === appearanceAnimation.NONE ? 1 : 0
    }">
    <div class="confirm-box-title-content" #elTitleWrapper *ngIf="confirmBoxBelonging.dispatch.title">
      <div class="dont-break-out">
        <div class="text-wrapper dont-break-out">
          <div class="confirm-box-title-text">
            {{ confirmBoxBelonging.dispatch.title }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-holder"
      #elTextWrapper
      [ngClass]="confirmBoxBelonging.dispatch.title ? '' : 'without-title'"
      *ngIf="confirmBoxBelonging.dispatch.message">
      <div class="icon-section" *ngIf="!confirmBoxBelonging.confirmBoxCoreConfig.disableIcon">
        <span [className]="getIconClasses()"></span>
      </div>
      <div class="text-wrapper-section confirm-box-inner-content">
        <div class="dont-break-out">
          <div class="text-wrapper" [innerHTML]="confirmBoxBelonging.dispatch.message"></div>
        </div>
      </div>
    </div>
    <div class="button-holder" #elButtonWrapper>
      <div
        class="button-section"
        *ngIf="confirmBoxBelonging.buttons.length"
        [ngStyle]="{
          'text-align': confirmBoxBelonging.confirmBoxCoreConfig.buttonPosition
        }">
        <button
          #elButton
          *ngFor="let button of confirmBoxBelonging.buttons"
          (click)="onCustomButton(button)"
          [className]="layoutHelper.getButtonClasses(button.layoutType, 'ed-btn ed-btn-md')">
          {{ button.label }}
        </button>
      </div>
      <div
        class="button-section"
        *ngIf="!confirmBoxBelonging.buttons.length"
        [ngStyle]="{
          'text-align': confirmBoxBelonging.confirmBoxCoreConfig.buttonPosition
        }">
        <button
          class="ed-btn ed-btn-md"
          #elButton
          (click)="onButtonClick('confirm')"
          [className]="
            layoutHelper.getButtonClasses(confirmBoxBelonging.confirmBoxCoreConfig.layoutType, 'ed-btn ed-btn-md', 'auto-button')
          ">
          {{ confirmBoxBelonging.confirmBoxCoreConfig.confirmLabel }}
        </button>
        <button
          class="ed-btn ed-btn-md ed-btn-secondary"
          #elButton
          (click)="onButtonClick('decline')"
          *ngIf="confirmBoxBelonging.confirmBoxCoreConfig.declineLabel">
          {{ confirmBoxBelonging.confirmBoxCoreConfig.declineLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
